/*
 * @Date: 2026-07-24
 * @Description: 场景管理路由（IAS 分角色）
 */

import SceneMgmtMain from '../views/scene-mgmt-main.vue';
import IPriceConfig from '../views/i-price-config.vue';
import APlanManual from '../views/a-plan-manual.vue';

export const route = [
  // 工业端
  {
    path: '/main/i/scene-mgmt',
    name: 'scene-mgmt-i',
    redirect: '/main/i/scene-mgmt/main',
    meta: {
      title: '场景管理',
      functionCode: 1
    },
    children: [
      {
        path: '/main/i/scene-mgmt/main',
        name: 'scene-mgmt-i-main',
        meta: {
          title: '场景管理',
          functionCode: 1
        },
        component: SceneMgmtMain
      },
      {
        path: '/main/i/scene-mgmt/i-price-config',
        name: 'scene-mgmt-i-price-config',
        meta: {
          title: '工业场景价格配置',
          parentPath: '/main/i/scene-mgmt/main',
          functionCode: 1
        },
        component: IPriceConfig
      }
    ]
  },
  // 服务商端

  {
    path: '/main/a/scene-mgmt/main',
    name: 'scene-mgmt-a-main',
    meta: {
      title: '场景管理',
      functionCode: 2
    },
    component: SceneMgmtMain
  },
  {
    path: '/main/a/scene-mgmt/a-plan-manual',
    name: 'scene-mgmt-a-plan-manual',
    meta: {
      title: '企业策划',
      parentPath: '/main/a/scene-mgmt/main',
      functionCode: 2
    },
    component: APlanManual
  }
];
